import { render } from "./BaseButtonLink.vue?vue&type=template&id=308a6e76&ts=true"
import script from "./BaseButtonLink.vue?vue&type=script&lang=ts"
export * from "./BaseButtonLink.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__